import React, { useRef, useState, useEffect } from "react"
import { DateRange } from "react-date-range"
import "react-date-range/dist/styles.css"
import "react-date-range/dist/theme/default.css"
import { addYears } from 'date-fns'

const DashboardOverviewFilter = ({ selectedFilter, setSelectedFilter }) => {
  return (
    <div className=' flex flex-col md:flex-row md:items-center md:justify-between gap-5'>
      {/* Filter by */}
      <div className='flex flex-row items-center divide-x divide-gray-200 rounded-md overflow-hidden border border-gray-300 dark:border-border-dark dark:bg-dark bg-white'>
        {Filters.map((filter, index) => (
          <button key={index}
            className={`${selectedFilter === filter ? "dark:text-gray-100 dark:bg-secondaryDark bg-white" : "dark:text-white"} text-black px-4 py-2 transition-all text-sm pointer-cursor duration-300 hover:bg-gray-50 dark:bg-dark dark:hover:bg-secondaryDark`} onClick={() => setSelectedFilter(filter)}>
            {filter}
          </button>
        ))}
      </div>


      {/* date range picker */}
      <div className="w-full md:w-fit flex items-end justify-end">
        <DateRangePickerDropdown />
     </div>

    </div>
  )
}

const Filters = [
  "12 months",
  "30 days",
  "7 days",
  "24 hours",
]

export default DashboardOverviewFilter

function formatDate(date) {
  return date
    ? date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
    : ""
}

export function DateRangePickerDropdown({ range, onChange }) {
  const [show, setShow] = useState(false)
  const [internalRange, setInternalRange] = useState(range || [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection"
    }
  ])
  const [appliedRange, setAppliedRange] = useState(internalRange)

  useEffect(() => {
    if (!range) return
    const normalized = range.map((item) => ({
      ...item,
      startDate: new Date(item.startDate),
      endDate: new Date(item.endDate),
    }))
    setInternalRange(normalized)
    setAppliedRange(normalized)
  }, [range])

  const ref = useRef()

  const handleApply = () => {
    const nextRange = internalRange.map((item) => ({
      ...item,
      startDate: new Date(item.startDate),
      endDate: new Date(item.endDate),
    }))
    setAppliedRange(nextRange)
    setInternalRange(nextRange)
    setShow(false)
    if (onChange) onChange(nextRange)
  }

  const handleCancel = () => {
    setInternalRange(appliedRange)
    setShow(false)
  }

  return (
    <div className="relative inline-block">
      <button
        className="bg-white dark:bg-dark border dark:border-border-dark dark:text-white px-4 py-2 rounded-md text-black flex flex-row items-center text-sm gap-2 transition-all duration-300"
        onClick={() => setShow((s) => !s)}
      >
        <svg className="text-gray-300 " width="20" height="21" viewBox="0 0 20 21" fill="#000" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_738_117688)">
            <path d="M17.5 9.28288H2.5M13.3333 2.61621V5.94954M6.66667 2.61621V5.94954M6.5 19.2829H13.5C14.9001 19.2829 15.6002 19.2829 16.135 19.0104C16.6054 18.7707 16.9878 18.3883 17.2275 17.9179C17.5 17.3831 17.5 16.683 17.5 15.2829V8.28288C17.5 6.88275 17.5 6.18268 17.2275 5.6479C16.9878 5.1775 16.6054 4.79504 16.135 4.55536C15.6002 4.28288 14.9001 4.28288 13.5 4.28288H6.5C5.09987 4.28288 4.3998 4.28288 3.86502 4.55536C3.39462 4.79504 3.01217 5.1775 2.77248 5.6479C2.5 6.18268 2.5 6.88275 2.5 8.28288V15.2829C2.5 16.683 2.5 17.3831 2.77248 17.9179C3.01217 18.3883 3.39462 18.7707 3.86502 19.0104C4.3998 19.2829 5.09987 19.2829 6.5 19.2829Z" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_738_117688">
              <rect width="20" height="20" fill="currentColor" transform="translate(0 0.949219)" />
            </clipPath>
          </defs>
        </svg>
        <p className=' text-black dark:text-white'>Select Dates</p>
      </button>
      {show && (
        <div
          ref={ref}
          className="absolute z-50 mt-2 bg-white dark:bg-dark border border-gray-300 dark:hover:border-border-dark rounded-xl shadow-md right-0"
          style={{
            minWidth: 300,
            maxWidth: '90vw',
            width: 700,
            overflowX: 'auto'
          }}
        >
          <DateRange
            editableDateInputs={true}
            onChange={item => setInternalRange([item.selection])}
            moveRangeOnFirstSelection={false}
            ranges={internalRange}
            months={2}
            direction="horizontal"
            rangeColors={["#FDBA2F"]}
            showMonthAndYearPickers={true}
            showDateDisplay={false}

          />
          <div className="flex items-center justify-between mt-4 gap-2 border-t border-gray-300 dark:hover:border-border-dark p-6">
            <div className="flex gap-2">
              <input
                className="border rounded-md px-3 py-2 text-sm dark:bg-secondaryDark dark:border-border-dark dark:text-white"
                value={formatDate(internalRange[0].startDate)}
                readOnly
              />
              <span className="mx-1">-</span>
              <input
                className="border rounded-md px-3 py-2 text-sm dark:bg-secondaryDark dark:border-border-dark dark:text-white"
                value={formatDate(internalRange[0].endDate)}
                readOnly
              />
            </div>
            <div className="flex gap-2 ">
              <button
                className="px-4 py-2 text-sm rounded-md border border-gray-300 bg-white text-black dark:bg-secondaryDark dark:border-border-dark dark:text-white"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-md bg-yellowcolor text-black font-medium text-sm"
                onClick={handleApply}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}